module.exports = __webpack_public_path__ + "static/media/ico-escribenos-correo.8cbe98ec.svg";